import Button from '@kawaui/button'
import Input from '@kawaui/input'
import Link from '@kawaui/link'
import Price from '@kawaui/price'
import { Radio } from '@kawaui/radio'
import styled, { css } from '@kawaui/theme'

import { NOTIFICATION_CONTAINER } from 'constants/index'
import { BREAKPOINTS, titleMedium, textMedium, mobileHeaderHeight, mobileHeaderMarginBottom } from 'styles/constants'

export const FlexWrapper = styled.div`
  display: flex;
`

export const Title = styled.p`
  padding: 0 0 ${({ theme }) => theme.space.s200} 0;

  background: inherit;

  color: ${({ theme }) => theme.colors.text.title};

  ${({ theme }) => css(theme.typography.heading.heading)}
`
export const SectionTitle = styled.div`
  ${({ theme }) => css(theme.typography.section.title)};
`
export const MyAddressesTitle = styled.h1`
  margin: 0 0 24px;

  color: ${({ theme }) => theme.colors.gray.s800};

  font-size: 26px;
  line-height: 30px;

  ${titleMedium}
`

export const Text = styled.p`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.space.s400};

  color: ${({ theme }) => theme.colors.text.body};

  text-align: left;

  ${({ theme }) => css(theme.typography.body.text)};
`

export const LineBase = styled.div`
  display: block;
  width: 100%;
  height: 1px;
  border-top: 1px solid ${({ theme }) => theme.colors.gray.s500};
  margin-bottom: ${({ theme }) => theme.space.s400};
`
export const ConfirmationLine = styled.div`
  display: none;
  width: 100%;
  height: 1px;
  border-top: 1px solid ${({ theme }) => theme.colors.gray.s300};

  margin-bottom: 30px;

  @media ${BREAKPOINTS.big} {
    display: block;
  }
`

export const StyledButton = styled(Button)`
  position: fixed;
  bottom: 24px;
  left: 0;

  width: calc(100% - 32px);
  margin: 0 16px;

  @media ${BREAKPOINTS.big} {
    position: relative;

    width: 336px;
    margin-top: 32px;
  }
`
export const LoaderWrapper = styled.div`
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
`

export const SectionWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.space.s400};
`

export const MobileAndTabletHeader = styled.div`
  /* note (juan.rueda): sticky doesn't work properly with IE or Safari */
  position: fixed;
  top: 0;

  display: flex;
  justify-content: space-between;

  width: 100%;
  height: ${mobileHeaderHeight};
  padding: 0.625rem ${({ theme }) => theme.space.s200};
  border-bottom: 2px solid #e1e1e4;
  margin-bottom: ${mobileHeaderMarginBottom};

  background: white;
`
export const MobileAndTabletBody = styled.div`
  /* note (juan.rueda): should add margin-top for the position: fixed in MobileAndTabletHeader */

  padding-bottom: ${({ theme }) => theme.space.s200};
  margin-top: calc(${mobileHeaderHeight} + ${mobileHeaderMarginBottom});

  background: ${({ theme }) => theme.colors.white.s100};
`

export const PageContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
`

export const BackButton = styled.div`
  display: flex;

  height: 30px;
  margin-right: 16px;
  margin-bottom: ${({ theme }) => theme.space.s400};

  cursor: pointer;
`
export const LeftOuterArrow = styled.div`
  width: 0;
  height: 0;

  border-top: 15px solid transparent;
  border-right: 15px solid ${({ theme }) => theme.colors.gray.s300};
  border-bottom: 15px solid transparent;
`
export const LeftInnerArrow = styled.div`
  position: relative;
  top: -13px;

  left: 1px;

  height: 0;

  border-top: 13px solid transparent;
  border-right: 14px solid ${({ theme }) => theme.colors.white.s100};
  border-bottom: 13px solid transparent;
`
export const BackButtonText = styled.p`
  padding: 0 ${({ theme }) => theme.space.s150} 0 ${({ theme }) => theme.space.s100};

  border: 1px solid ${({ theme }) => theme.colors.gray.s300};
  border-left: none;

  color: ${({ theme }) => theme.colors.gray.s700};
  font-size: 14px;

  line-height: 30px;

  border-radius: 0 ${({ theme }) => theme.radius.s200} ${({ theme }) => theme.radius.s200} 0;

  ${textMedium};

  user-select: none;
`
export const TotalPrice = styled(Price)`
  color: ${({ theme }) => theme.colors.main.base};
`

export const CustomRadio = styled(Radio)`
  /* Display & Box Model */
  align-items: flex-start;
`
export const CustomDropPointRadio = styled(CustomRadio)`
  padding-bottom: ${({ theme }) => theme.space.s100};
  border-bottom: 1px solid #e1e1e4;
  margin-top: ${({ theme }) => theme.space.s200};

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.desktop}) {
    padding-bottom: ${({ theme }) => theme.space.s300};
  }
`
export const MainLabel = styled.div`
  text-transform: capitalize;

  ${({ theme }) => css(theme.typography.body.text)};
`

export const ExtraLabel = styled.div`
  ${({ theme }) => css(theme.typography.body.smallTextRegular)};
`
export const Column = styled.div`
  width: ${({ cols }) => (cols * 100) / 12}%;
`

export const FloatNavWrapper = styled.div`
  /* Positioning */
  position: fixed;
  top: 0;

  /* Display & Box Model */
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: ${({ theme }) => theme.space.s100};
`

export const Action = styled.div`
  /* Display & Box Model */
  display: flex;
  padding: 5px;

  background: white;

  border-radius: 100%;
  cursor: pointer;

  ${({ theme, hasScrolled }) =>
    hasScrolled &&
    css`
      box-shadow: ${theme.shadow.s200};
    `}

  transition: box-shadow 0.5s;
`
export const PageCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: ${({ theme }) => theme.space.s700} ${({ theme }) => theme.space.s300};

  ${({ theme }) => css(theme.typography.body.text)};

  @media ${BREAKPOINTS.noMobile} {
    min-height: 480px;
    padding: ${({ theme }) => theme.space.s300};
    border: ${({ theme }) => theme.border.s100} solid ${({ theme }) => theme.colors.gray.s300};

    border-radius: ${({ theme }) => theme.radius.s300};
  }
`
export const ScrollablePageWrapper = styled.div`
  display: flex;
  justify-content: center;
  overflow: auto;
  width: 100%;
  height: 100%;

  @media ${BREAKPOINTS.noMobile} {
    padding: ${({ theme }) => theme.space.s200} 0;
  }
`

export const Rectangle = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.space.s200};
  border: solid 1px #e1e1e4;
  margin-bottom: ${({ theme }) => theme.space.s300};

  border-radius: ${({ theme }) => theme.radius.s200};
`

export const BoldTextMain = styled.span`
  ${({ theme }) => css(theme.typography.body.boldTextMain)};
`
export const BoldSmallText = styled.span`
  ${({ theme }) => css(theme.typography.body.boldSmallText)};
`
export const SmallText = styled.span`
  ${({ theme }) => css(theme.typography.body.smallText)};
`

export const CancellableWrapper = styled.div`
  width: 100%;

  @media ${BREAKPOINTS.small} {
    display: flex;
    flex-direction: column;

    min-height: 100%;
    padding: ${({ theme }) => theme.space.s700} ${({ theme }) => theme.space.s300};
  }
`
export const NotCancellableWrapper = styled(CancellableWrapper)``

export const CancelReasonDropdownWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.space.s300};
`

export const SideMenuWrapper = styled.div`
  position: fixed;

  height: 100%;

  ${({ isStickyToBottom }) =>
    isStickyToBottom &&
    css`
      position: inherit;
      display: flex;
      justify-content: flex-end;
      flex-direction: column;
    `};
`
export const SideMenuStyled = styled.div`
  width: 220px;
  padding: ${({ theme }) => theme.space.s150} ${({ theme }) => theme.space.s150} ${({ theme }) => theme.space.s100}
    ${({ theme }) => theme.space.s200};
  border: 1px solid ${({ theme }) => theme.colors.gray.s300};

  background-color: ${({ theme }) => theme.colors.white.s100};

  a {
    text-decoration: none;
  }
`
export const MenuTitle = styled.div`
  display: block;
  padding: ${({ theme }) => theme.space.s025} ${({ theme }) => theme.space.s100};
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray.s300};
  margin-bottom: ${({ theme }) => theme.space.s100};

  background: ${({ theme }) => theme.colors.gray.s200};

  cursor: pointer;
`
export const StyledTitleLink = styled(Link)`
  ${({ theme }) => css(theme.typography.body.smallTextMain)};

  ${({ isActive }) =>
    isActive &&
    css`
      ${({ theme }) => css(theme.typography.body.boldSmallTextMain)};
    `};
`
export const MenuSection = styled.div`
  padding: 0 ${({ theme }) => theme.space.s150} ${({ theme }) => theme.space.s400};
`
export const StyledTextLink = styled(Link)`
  cursor: pointer;
  ${({ theme }) => css(theme.typography.body.smallTextRegular)};

  ${({ isActive }) =>
    isActive &&
    css`
      ${({ theme }) => css(theme.typography.body.boldSmallText)};
    `};
`

export const SubHeading = styled.div`
  ${({ theme }) => css(theme.typography.heading.subheading)};
`

export const SideNavigationWrapper = styled.div`
  padding: 0 ${({ theme }) => theme.space.s200};
`

export const CompleteIconSettings = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.space.s100} ${({ theme }) => theme.space.s200};
  border: 1px solid ${({ theme }) => theme.colors.main.base};
  margin-bottom: ${({ theme }) => theme.space.s200};

  color: ${({ theme }) => theme.colors.main.base};

  border-radius: ${({ theme }) => theme.space.s025};
  cursor: pointer;
  gap: ${({ theme }) => theme.space.s100};
`

export const RelativeWrapper = styled.div`
  position: relative;
`
export const InputWithPadding = styled(Input)`
  & input {
    padding: 0 2.5rem;
    :focus {
      padding: 0 2.5rem;
    }
  }
`
export const MinWidthButton = styled(Button)`
  min-width: 288px;
`

export const PreLineText = styled.span`
  white-space: pre-line;
`

export const ImgWrapper = styled.div`
  max-width: 400px;
`

export const MoreInfoText = styled.div`
  ${({ theme }) => theme.typography.body.smallTextRegular};
`
export const MoreInfoStyledLink = styled(Link)`
  ${({ theme }) => theme.typography.body.smallText};
`

export const NotificationContainer = styled.div.attrs(() => ({
  id: NOTIFICATION_CONTAINER,
}))`
  position: fixed;

  width: 100%;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`
